export default "__VITE_ASSET__CivZbs6s__"